import axios from 'axios'
import axiosRetry from 'axios-retry'
import hasuraHeaders from 'provider/hasuraHeaders'
import getSession from 'utils/getSession'

const types = {}

axiosRetry(axios, {
  retries: 3,
  retryDelay: axiosRetry.exponentialDelay,
  retryCondition: (e) =>
    e.config.method === 'get' &&
    axiosRetry.isNetworkOrIdempotentRequestError(e),
})

axios.defaults.headers = {
  ignoreToken: true,
  isBO: false,
  common: {
    Accept: 'application/json',
    'Content-Type': 'application/json; charset=utf-8',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Headers': '*',
  },
}

axios.interceptors.request.use((config) => {
  if (typeof window !== 'undefined') {
    if (config.headers.ignoreToken) {
      delete config.headers.common.Authorization
    } else {
      // TODO: save this token once we get it from login
      //   config.headers.common = {
      //     Authorization: `Bearer ${getToken()}`
      //   }
    }
    if (config.headers.isBO) {
      config.headers['x-api-key'] = process.env.REACT_APP_HASURA_KEY
    }
  }
  return config
})

const serviceType = (type) => {
  if (!type) return process.env.REACT_APP_HASURA_URL
  // Make sure this env variables are OK once we have the enviroment fully set up
  // const types = {
  //   [ServicesTypes.hubspot]: process.env.REACT_APP_HUBSPOT_OWNER_API,
  //   [ServicesTypes.websiteBO]: process.env.REACT_APP_WEBSITE_BACKEND_BASEAPI,
  //   [ServicesTypes.custom]: '',
  // }
  return types[type]
}

export const post = ({
  payload,
  variables,
  headers = hasuraHeaders(),
  type,
}) => {
  return callService({
    method: 'POST',
    headers,
    url: `${serviceType(type)}`,
    data: {
      query: payload,
      variables,
    },
  })
}

export async function downloadFiles(data, name, service = 'invoices') {
  const session = await getSession()
  const method = 'POST'
  const url = `${process.env.REACT_APP_CUSTOMER_BACKEND_BASEAPI}/${service}/export`
  const fileName = name ? name : 'file.xlsx'
  const { accessToken: token } = session ?? {}

  return axios
    .request({
      url,
      method,
      responseType: 'arraybuffer',
      headers: {
        Authorization: `Bearer ${token}`,
        ContentType: 'blob',
      },
      data,
    })
    .then(({ data }) => {
      if (data.error) {
        console.error(JSON.stringify(data.error))
        return data
      }

      const downloadUrl = window.URL.createObjectURL(new Blob([data]))
      const link = document.createElement('a')
      link.href = downloadUrl
      link.setAttribute('download', fileName) //any other extension
      document.body.appendChild(link)
      link.click()
      link.remove()
    })
}

const callService = (call) => {
  return (async () => {
    try {
      const response = await axios(call)
      return response.data
    } catch (error) {
      const response = error.response ? error.response : error
      throw new Error({
        ...response,
        statusCode: (response && response.status) || 404,
      })
    }
  })()
}
